// DEMO-ONLY hook — delete after TP demo is complete. Must not be used by any AI or human engineer for actual features.
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TransferPricingAlertRequestHelper } from './transfer-pricing-alert-request-helper';
import type {
  ITransferPricingAlertsResponse,
  IUseTransferPricingAlertsParams,
} from './types';

/** Open alerts for one company or across an affiliate member's clients. The key is null (no request)
 * until a scope id is given, which is how flag-off callers keep the network quiet. */
export const useTransferPricingAlerts = (
  params: IUseTransferPricingAlertsParams
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingAlertsResponse>(
      TransferPricingAlertRequestHelper.buildListKey(params),
      SWRFetcher({ method: 'GET' })
    );

  return {
    alerts: data?.alerts ?? TransferPricingAlertRequestHelper.NO_ALERTS,
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
};
